const REG_URL = /((http|https|ftp){1}\:\/\/)?([a-zA-Z0-9\-\.]+[a-zA-Z0-9]+\.(net|cn|co|hk|tw|com|edu|gov|us|int|mil|org|int|mil|vg|uk|idv|tk|se|nz|nu|nl|ms|jp|jobs|it|ind|gen|firm|in|gs|fr|fm|eu|es|de|bz|be|at|am|ag|mx|asia|ws|xxx|tv|cc|ca|mobi|me|biz|arpa|info|name|pro|aero|coop|museum|ly|eg|mk|io)(:[a-zA-Z0-9]*)?\/?(\.?[@a-zA-Z0-9\-_\?\'\/\\\+&amp;%\$#\=~]+)*)+/gi;
export function autoLink(text) {
  text = text || "";
  text = text.replace(REG_URL, function(match) {
    if (-1 == match.indexOf("http") && -1 == match.indexOf("https")) {
      match = location.protocol + "//" + match;
    }
    return `<a href="${match}" target="_blank">${match}</a>`;
  });
  return text;
}
